import React, { useState } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Select from "react-select";
import { useAuth } from "../context/AuthContext";

const PROFESSIONAL_ROLE_OPTIONS = [
  { value: "RN", label: "Registered Nurse (RN)" },
  { value: "RM", label: "Registered Midwife (RM)" },
  { value: "RMN", label: "Registered Mental Health Nurse (RMN)" },
  { value: "RNLD", label: "Learning Disabilities Nurse (RNLD)" },
  { value: "RSCN", label: "Registered Sick Children's Nurse (RSCN)" },
  { value: "HCA2", label: "Band 2 Healthcare Assistant" },
  { value: "HCA3", label: "Band 3 Healthcare Assistant" },
  { value: "LDOC", label: "Locum Doctor (LDOC)" },
  { value: "LCON", label: "Locum Consultant (LCON)" },
  { value: "SUPPORT_WORKER", label: "Support worker" },
  { value: "RADIOGRAPHER", label: "Radiographer" },
  { value: "PHYSIOTHERAPIST", label: "Physiotherapist" },
  { value: "LAB_ASSISTANT", label: "Lab assistant" },
  { value: "BIO_MEDICAL_SCIENTIST", label: "Bio-medical scientist" },
  { value: "SPEECH_THERAPIST", label: "Speech therapist" },
  { value: "OCCUPATIONAL_THERAPIST", label: "Occupational therapist" },
  { value: "PHARMACIST", label: "Pharmacist" },
];

const UserProfessionalRoleSelection = ({ user, onComplete, close }) => {
  const { authAxios } = useAuth();
  const [selectedRole, setSelectedRole] = useState(null);
  const [saving, setSaving] = useState(false);

  const roleFlagsFromSelection = (role) => ({
    rn: role === "RN",
    rm: role === "RM",
    rmn: role === "RMN",
    rnld: role === "RNLD",
    rscn: role === "RSCN",
    hca2: role === "HCA2",
    hca3: role === "HCA3",
    ldoc: role === "LDOC",
    lcon: role === "LCON",
    supportWorker: role === "SUPPORT_WORKER",
    radiographer: role === "RADIOGRAPHER",
    physiotherapist: role === "PHYSIOTHERAPIST",
    labAssistant: role === "LAB_ASSISTANT",
    bioMedicalScientist: role === "BIO_MEDICAL_SCIENTIST",
    speechTherapist: role === "SPEECH_THERAPIST",
    occupationalTherapist: role === "OCCUPATIONAL_THERAPIST",
    pharmacist: role === "PHARMACIST",
  });

  const saveRole = async (e) => {
    e.preventDefault();
    if (!selectedRole || !user?.id) return;

    try {
      setSaving(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const response = await authAxios().post(
        "/api/backoffice/users/update",
        {
          id: user.id,
          forename: user.forename,
          surname: user.surname,
          email: user.email,
          password: null,
          role: user.role,
          status: user.status,
          staffNumber: user.staffNumber,
          nmcNumber: user.nmcNumber,
          accessNiNumber: user.accessNINumber,
          telephone: user.telephone,
          dob: user.dob,
          startDate: user.startDate
            ? new Date(user.startDate).toISOString()
            : null,
          ...roleFlagsFromSelection(selectedRole),
        },
        config,
      );

      setSaving(false);
      if (onComplete !== null && onComplete !== undefined) {
        onComplete(response.data);
      }
    } catch (error) {
      setSaving(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  const declaredRoleText = user?.declaredRole?.trim();

  return (
    <Form onSubmit={saveRole}>
      <Alert variant="warning">
        This user has not had a professional role selected.
        {declaredRoleText ? (
          <div className="mt-2">
            Declared role: <strong>{declaredRoleText}</strong>
          </div>
        ) : (
          <div className="mt-2">No declared role was entered.</div>
        )}
      </Alert>
      <Form.Group controlId="formProfessionalRole">
        <Form.Label>Professional role</Form.Label>
        <Select
          className={"fs-input"}
          isClearable={true}
          options={PROFESSIONAL_ROLE_OPTIONS}
          onChange={(roleOption) => setSelectedRole(roleOption?.value)}
          value={
            PROFESSIONAL_ROLE_OPTIONS.find(
              (option) => option.value === selectedRole,
            ) || null
          }
          placeholder="Select role"
        />
      </Form.Group>
      <Modal.Footer className={"mb-0 pb-0"}>
        <Container fluid>
          <Row className="mb-3 align-content-center">
            <Col>
              <Button
                className="w-100"
                variant="secondary"
                type="button"
                onClick={close}
              >
                Close
              </Button>
            </Col>
            <Col>
              <Button
                className="w-100 h-100"
                variant="outline-offblack"
                type="submit"
                disabled={!selectedRole || saving}
              >
                Save role
              </Button>
            </Col>
          </Row>
        </Container>
      </Modal.Footer>
    </Form>
  );
};

export default UserProfessionalRoleSelection;
